export type StyleFactoryArgs = [components?: unknown, options?: unknown];

export interface ErrorTextStyle {
  color: string;
  fontStyle: string;
  fontWeight: string;
  fontSize: number;
  lineHeight: string;
}

export const getErrorTextStyle: (...args: StyleFactoryArgs) => ErrorTextStyle = () => ({
  color: '#A80000',
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: 12,
  lineHeight: '16px',
});
